export default __webpack_public_path__ + "static/media/profilePic-6.deeef10f.jpg";